import styled from "@emotion/styled";

export const CommodityActionCellCenterAlign = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
